<template>
	<div class="main-containter" id="top" v-title data-title="北京和合网链科技有限公司">
		<PHeader :checkId="'红色建设32'"  :activeNames="'关于我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">关于我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">About Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 关于我们</span>
				<span style="color:#333333;font-size:14px;"> / 红色建设</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">红色建设</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Red Construction</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>
			<div style="width:94%;margin-left:3%;margin-bottom:20px;">
				<div style="height:190px;border:1px solid #E0E0E0;margin-top:30px;" v-for="(item,index) in tableList" :key="index">
					<div style="width: 94%;color: rgb(51, 51, 51);overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 15px;margin-left: 3%;font-size: 18px;font-weight: 600;">
						{{item.title}}
					</div>
					
					<div style="margin-top: 15px;height: 80px;width: 94%;color: rgb(89, 89, 89);overflow: hidden;margin-left: 3%;display: -webkit-box;-webkit-line-clamp: 4;line-height: 20px;-webkit-box-orient: vertical;margin-bottom: 10px;">
						{{item.description}}
					</div>
					<div style="font-size: 14px;border-top: 1px solid rgb(229, 229, 229);width: 94%;margin-left: 3%;font-weight: 900;color: rgb(170, 170, 170);padding-top: 10px;">
							<div style="float: left;">{{item.publish.substring(0,10)}}</div>
							<img  @click="toDetail(item,index)" style="float: right;transform: rotate(-90deg);" src="../../assets/fImage/xiangyoujiantou.svg">
						</div>
				</div>
			</div>
			
			<el-pagination
				background
				layout="prev, pager, next"
				:page-size="4"
				:total="total"
				@current-change="handleCurrentChange">
			</el-pagination>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {query} from "@/api/aboutUs";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				tableList: [],
				total:0,
				pageNo: 1,
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			async toDetail(item,index){
				this.$router.push(
					{
						path:'/phone/redConstructionDetail',
						query:{
							id:item.id,
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			list() {
				let param = {
					title: '',
					channelId: null,
					page: this.pageNo,
					pageSize: 4,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
div ::v-deep .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div ::v-deep .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div ::v-deep .el-pagination{
	text-align: center;
	margin-bottom: 20px;
}
</style>
